export default "__VITE_ASSET__BREdfcL8__"